import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackMetaEvent } from "../utils/metaEvents";

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    let cancelled = false;

    // Esperar a que fbq esté disponible y disparar PageView deduplicado
    // (navegador + Conversions API con el mismo event_id).
    const trackPageView = (attempt = 0) => {
      if (cancelled) return;
      if (window.fbq) {
        trackMetaEvent("PageView");
      } else if (attempt < 50) {
        // Reintentar hasta ~5s si fbq aún no cargó.
        setTimeout(() => trackPageView(attempt + 1), 100);
      }
    };

    const timeoutId = setTimeout(() => trackPageView(), 50);

    // Google Analytics (si lo tienes configurado)
    if (window.gtag) {
      window.gtag("config", "G-XXXXXXXXXX", {
        page_path: location.pathname + location.search,
      });
    }

    return () => {
      cancelled = true;
      clearTimeout(timeoutId);
    };
  }, [location]);
};
